import * as React from 'react';

function SvgAmericanExpressColourSquare(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="AmericanExpressColourSquare_svg__a"
        maskUnits="userSpaceOnUse"
        x={2}
        y={7}
        width={26}
        height={17}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 7.206h25.882v16.177H2V7.206z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#AmericanExpressColourSquare_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.882 22.52a.863.863 0 01-.863.863H2.863A.862.862 0 012 22.52V8.07c0-.477.386-.863.863-.863h24.156c.477 0 .863.386.863.863V22.52z"
          fill="#0078A9"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.03 14.918v-.259l-.124.259H8.835L8.7 14.64v.278H6.697l-.236-.56h-.402l-.25.56H4.77v-1.691l.761-1.723H6.99l.205.488v-.484h1.782l.393.822.383-.826h5.628s.295-.004.49.133l-.002-.133h1.418v.187s.255-.187.632-.187h2.502l.22.495v-.495h1.603l.29.495v-.495h1.533v3.417h-1.574l-.37-.596v.593h-1.957l-.276-.61h-.383l-.258.61h-1.185s-.441-.006-.772-.243v.243h-2.359v-.797c0-.116-.088-.108-.088-.108h-.087v.905H10.03zM8.854 15.658h3.098l.447.506.458-.506h2.382s.224.005.436.119v-.12h2.122c.269 0 .495.135.495.135v-.134h2.727v.124s.194-.124.455-.124h1.777v.124s.223-.124.46-.124h1.395v3.22s-.184.207-.563.207h-1.839v-.102s-.175.102-.442.102h-4.884v-.832c0-.082-.036-.097-.109-.097h-.067v.929h-1.527v-.923s-.17.09-.452.09h-.549v.833h-1.882l-.428-.522-.458.522H8.854v-3.427z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.62 16.172h1.944v.521h-1.35v.455h1.312v.46h-1.311v.477h1.349v.51h-1.945v-2.423zM24.32 17.116c.731.037.793.402.793.791 0 .454-.374.698-.763.698H23.1v-.52h.974c.165 0 .411 0 .411-.232 0-.11-.043-.181-.219-.2a7.013 7.013 0 00-.41-.028c-.661-.017-.815-.345-.815-.745 0-.454.32-.703.709-.703h1.249v.52h-.914c-.208.002-.433-.025-.433.21 0 .148.111.178.252.192.049 0 .373.017.417.017zM22.08 17.116c.732.037.793.402.793.791 0 .454-.373.698-.763.698h-1.248v-.52h.973c.165 0 .41 0 .41-.232 0-.11-.043-.181-.219-.2a7.047 7.047 0 00-.41-.028c-.661-.017-.814-.345-.814-.745 0-.454.32-.703.708-.703h1.25v.52h-.915c-.208.002-.432-.025-.432.21 0 .148.111.178.252.192.048 0 .373.017.416.017zM14.828 17.278h-.74v-.581h.743c.249 0 .327.16.327.278 0 .163-.086.303-.33.303zm-1.34 1.089l-.855-1.011.854-.947v1.958zm-2.274-.281H9.842v-.479h1.312v-.46H9.842v-.454l1.447.003.579.66-.654.73zm3.814-1.91h-2.087l-.681.753-.66-.757H9.256v2.422h2.268l.714-.8.697.806h1.142v-.823h.8c.308 0 .87-.01.87-.86 0-.605-.426-.74-.719-.74zM17.388 17.246h-.74v-.55h.743c.249 0 .327.16.327.28 0 .161-.086.27-.33.27zm.514.25c.325-.162.41-.378.41-.67 0-.519-.42-.649-.713-.649h-1.546V18.6h.595v-.855h.778c.206 0 .287.206.292.411l.016.444h.579l-.022-.498c0-.39-.107-.573-.39-.606z"
        fill="#0078A9"
      />
      <mask
        id="AmericanExpressColourSquare_svg__b"
        maskUnits="userSpaceOnUse"
        x={2}
        y={7}
        width={26}
        height={17}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 23.383h25.882V7.206H2v16.177z"
          fill="#fff"
        />
      </mask>
      <g
        mask="url(#AmericanExpressColourSquare_svg__b)"
        fillRule="evenodd"
        clipRule="evenodd"
        fill="#0078A9"
      >
        <path d="M16.291 14.415h.595v-2.426h-.595v2.426zM11.422 11.992h1.944v.522h-1.35v.454h1.312v.46h-1.311v.478h1.349v.509h-1.944v-2.423zM15.054 13.06h-.74v-.548h.743c.249 0 .328.16.328.278 0 .163-.087.27-.33.27zm.514.251c.325-.161.411-.378.411-.67 0-.52-.421-.649-.713-.649h-1.547v2.423h.595v-.855h.778c.206 0 .287.206.293.411l.016.444h.578l-.02-.498c0-.39-.11-.573-.39-.606zM5.86 13.351l.354-.847.37.847h-.725zm4.19-1.359l-.73 1.625-.727-1.625H7.66v2.333l-1.038-2.333h-.787l-1.06 2.423h.627l.233-.541h1.187l.235.54h1.198v-1.797l.795 1.798h.54l.814-1.769v1.769H11v-2.423h-.949zM19.37 13.352l.354-.846.373.846h-.727zm3.653-1.361v1.677l-1.003-1.677h-.879v2.275l-1.013-2.274h-.787l-.82 1.877s-.346 0-.38-.009c-.144-.03-.368-.13-.37-.557v-.176c0-.568.308-.61.703-.61h.367v-.526h-.776c-.27 0-.86.206-.879 1.202-.014.67.279 1.223.938 1.223h.785l.232-.54h1.187l.235.54h1.174v-1.774l1.07 1.774h.811v-2.425h-.595z" />
      </g>
    </svg>
  );
}

export default SvgAmericanExpressColourSquare;
